import { OutboundTripDetailDestinationDto } from 'dtos/outboundTrips'
import * as yup from 'yup'
import { OutboundTripDestinationAddressDtoValidator } from './OutboundTripDestinationAddressDtoValidator'
import { OutboundTripDestinationCompanyDtoValidator } from './OutboundTripDestinationCompanyDtoValidator'

export const OutboundTripDetailDestinationDtoValidator = yup.object<OutboundTripDetailDestinationDto>({
  destinationCompany: OutboundTripDestinationCompanyDtoValidator.required('Buyer or Exporter Company is required.'),
  destinationCompanyAddress: yup.object({ addressGuid: yup.string().required('Vehicle Destination Address is required.') }),
  destinationAddress: OutboundTripDestinationAddressDtoValidator.required('Outbound Trip Destination Address is required.')
})
